import { connectBlocksFrom } from '@uploadcare/blocks/abstract/connectBlocksFrom.js';

connectBlocksFrom('https://unpkg.com/@uploadcare/blocks@0.14.3/web/blocks-browser.min.js');
